export class UserState {

    constructor() { }

    public TenantID: string;
    public JurisID: string;
    public JurisNo: number;
    public JurisName: string;
    public Latitude: number;
    public Longitude: number;
    public Location: string;
    public Address2: string;
    public City: string;
    public State: string;
    public StateName: string;
    public Zip: string;
    public ZipCode: string;
    public PhoneNumber: string;
    public PhoneExtension: string;
    public FaxNumber: string;
    public FaxExtension: string;
    public FileAttachment: string;
    public FileType: string;
    public LogoSize: string;
    public LogoPath: string;

    public LoggedInUserId: string;
    public LoggedInUserRole: number;
    public UserName: string;
    public Email: string;
    public Lang: string;
    public Token: string;
    public PhoenixKey: string;

    public BGPath: string;
    public BGFileType: string;
    public IsParkingPermitEnabled: boolean;
    public IsTaxicomplaintEnabled: boolean;
    public IsRecoverPwd: number;
    public JurisEmail: string;
    public EmailID: string;

    public pawnMenu: boolean
    public RegStatus: string;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/userstate.model.ts